import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { connect } from "react-redux";
import constantsReport from "./constants/WhichTypeSelect";
import reportAction from "../../../store/actions/reportAction";

const TabSeparationReport = ({
  emptyCampaignsDataSeparation,
  whichTypeSelect,
  dateFrom,
  dateTo,
  sitePublisherID,
  getSitePublisherDataSeparation,
  setTypeSeparationDataChart,
}) => {
  const clickSeparationItemHandler = (selectedKey) => {
    const separate = selectedKey.target.getAttribute("data-rr-ui-event-key");

    emptyCampaignsDataSeparation({});
    setTypeSeparationDataChart({
      separation: separate,
    });

    if (whichTypeSelect == constantsReport.SPECIFIC_SITE_PUBLISHER) {
      getSitePublisherDataSeparation({
        sitePublisherID,
        dateFrom,
        dateTo,
        separation: separate,
      });
    }
  };

  return (
    whichTypeSelect === constantsReport.SPECIFIC_SITE_PUBLISHER && (
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 container-tab-separation-report pt-3 pr-3">
        <div dir="rtl">
          <Tabs
            className="d-inline-flex flex-lg-nowrap pt-1"
            onClick={(selectedKey) => {
              clickSeparationItemHandler(selectedKey);
            }}
          >
            <Tab eventKey="position" title="به تفکیک جایگاه"></Tab>
            <Tab eventKey="time" title="به تفکیک زمان"></Tab>
          </Tabs>
        </div>
      </div>
    )
  );
};

const mapStateToProps = (state) => {
  return {
    sitePublisherID: state.report.site_publisher_ID,
    whichTypeSelect: state.report.which_type_select,
    dateFrom: state.report.date_from,
    dateTo: state.report.date_to,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    emptyCampaignsDataSeparation: (action) => {
      dispatch({
        type: reportAction.EMPTY_SITE_PUBLISHER_DATA_SEPARATION,
        payload: action,
      });
    },
    setTypeSeparationDataChart: (action) => {
      dispatch({
        type: reportAction.SET_TYPE_SEPARATION_DATA_CHART,
        payload: action,
      });
    },
    getSitePublisherDataSeparation: (action) => {
      dispatch({
        type: reportAction.GET_SITE_PUBLISHER_SEPARATION_DATA_CHART,
        payload: action,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabSeparationReport);
